import React from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HandshakeIcon from '@mui/icons-material/Handshake';
import KeyIcon from '@mui/icons-material/Key';

const steps = [
  { icon: <SearchIcon sx={{ fontSize: 28, color: '#fff' }} />, title: 'Search & Discover', desc: 'Buyer searches by location, budget, BHK, and filters to find matching properties.', color: '#4338ca', bg: 'linear-gradient(135deg, #4338ca, #6366f1)' },
  { icon: <FavoriteIcon sx={{ fontSize: 28, color: '#fff' }} />, title: 'Shortlist & Save', desc: 'Buyer adds properties to wishlist and shares them with family for review.', color: '#7c3aed', bg: 'linear-gradient(135deg, #7c3aed, #a78bfa)' },
  { icon: <CalendarMonthIcon sx={{ fontSize: 28, color: '#fff' }} />, title: 'Schedule Site Visit', desc: 'Buyer books a site visit directly from the portal. Your team gets notified instantly.', color: '#0891b2', bg: 'linear-gradient(135deg, #0891b2, #22d3ee)' },
  { icon: <HandshakeIcon sx={{ fontSize: 28, color: '#fff' }} />, title: 'Negotiate & Book', desc: 'Sales team follows up and the buyer initiates booking from within the portal.', color: '#059669', bg: 'linear-gradient(135deg, #059669, #34d399)' },
  { icon: <KeyIcon sx={{ fontSize: 28, color: '#fff' }} />, title: 'Possession & Move-in', desc: 'Track payment schedules and handover dates. Buyer gets updates at every milestone.', color: '#dc2626', bg: 'linear-gradient(135deg, #dc2626, #f87171)' },
];

const BuyerJourney = () => (
  <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: '#ffffff' }}>
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography sx={{ color: '#4338ca', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 1.5, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>End-to-End Buyer Journey</Typography>
        <Typography variant="h2" sx={{ fontWeight: 900, color: '#1e1b4b', fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '2rem', md: '2.8rem' } }}>
          From Search to Possession — All on Your Portal
        </Typography>
      </Box>

      {/* Attractive step cards in a Grid — no overflow scroll on mobile */}
      <Grid container spacing={3}>
        {steps.map((s, i) => (
          <Grid item xs={12} sm={6} md key={i} sx={{ display: 'flex' }}>
            <Box sx={{
              flex: 1, borderRadius: '24px', p: 3.5,
              bgcolor: '#ffffff',
              border: '1px solid #f1f5f9',
              boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
              display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
              transition: 'all 0.3s',
              '&:hover': { transform: 'translateY(-8px)', boxShadow: '0 20px 50px rgba(0,0,0,0.08)' },
              position: 'relative', overflow: 'hidden',
            }}>
              {/* Top accent bar */}
              <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: s.bg }} />

              {/* Step number */}
              <Box sx={{ position: 'absolute', top: 16, right: 16, width: 26, height: 26, borderRadius: '8px', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography sx={{ color: '#fff', fontWeight: 900, fontSize: 12, fontFamily: "'Montserrat', sans-serif" }}>{String(i + 1).padStart(2, '0')}</Typography>
              </Box>

              {/* Icon circle */}
              <Box sx={{ width: 70, height: 70, borderRadius: '50%', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, boxShadow: `0 10px 30px ${s.color}40`, mt: 1 }}>
                {s.icon}
              </Box>

              <Typography sx={{ fontWeight: 800, color: '#1e1b4b', fontSize: '1rem', mb: 1.5, fontFamily: "'Montserrat', sans-serif" }}>{s.title}</Typography>
              <Typography sx={{ color: '#64748b', fontSize: 13.5, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.65 }}>{s.desc}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default BuyerJourney;
